import Vue from 'vue';
import axios from 'axios';
import vSelect from "vue-select";
import { circleMarker, latLngBounds } from "leaflet";
import { LMap, LTileLayer, LCircleMarker, LPopup, LControl } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: 'app',
  components: {
    vSelect,
    LMap,
    LTileLayer,
    LCircleMarker,
    LPopup,
    LControl
  },
  data () {
    return {
      loading: true,
      building: {
        cities: false,
        counties: false,
        regions: false,
        care: false
      },
      zoom: 6,
      minZoom: 5,
      maxZoom: 12,
      bounds: null,
      center: [31.5, -100],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      currentCenter: [31.5, -100],
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: false
      },
      serviceColors: {
        'SA': '#fb2056', //accent
        'MH': '#1e90ff' //dodger
      },
      cities: [],
      counties: [],
      regionOptions: [],
      selectedCities: [],
      selectedCounties: [],
      selectedRegions: [],
      selectedCare: [],
      facilities: [],
      filteredFacilities: [],
      services: [],
      regions: [],
      careOptions: [],
      showFacilitiesList: false,
      showServices: false,
      popupFacility: false,
      facilityDetails: [
        { code: 'TC', name: 'Type of Care' },
        { code: 'FT', name: 'Facility Type' },
        { code: 'FOP', name: 'Facility Operation' },
        { code: 'LCA', name: 'License/Certification' },
        { code: 'PAY', name: 'Payment/Insurance' },
        { code: 'SG', name: 'Special Programs' },
        { code: 'AS', name: 'Ancillary Services' },
        { code: 'EDU', name: 'Counseling Services' },
        { code: 'TAP', name: 'Treatment Approach' },
        { code: 'EXCL', name: 'Exclusive Services' },
        { code: 'OL', name: 'Languages' },
        { code: 'DEM', name: 'Demographics (Age and Gender)' }
      ]
    };
  },
  mounted() {
    let $this = this;
    axios.all([
      axios.get(wordpress.apiUrl + 'treatment-map/facilities'),
      axios.get(wordpress.apiUrl + 'treatment-map/services'),
      axios.get(wordpress.apiUrl + 'treatment-map/regions')
    ])
    .then(axios.spread(function (facilities, services, regions) {
      $this.facilities = facilities.data;
      $this.services = services.data;
      $this.regions = regions.data;
      $this.buildFilteredFacilities();
      $this.rebuildOptions();
      $this.stopLoading();
    }));
  },
  watch: {
    selectedCities: function(val) {
      this.loading = true;
      this.watchSelected();

      this.buildCounties();
      this.buildRegionOptions();
      this.buildCareOptions();

      if (val.length === 0) {
        this.buildCities();
      }
    },
    selectedCounties: function() {
      this.loading = true;
      this.watchSelected();
    },
    selectedRegions: function() {
      this.loading = true;
      this.watchSelected();
    },
    selectedCare: function() {
      this.loading = true;
      this.watchSelected();
    },
  },
  computed: {
  },
  methods: {
    buildFilteredFacilities() {
      this.filteredFacilities = [];
      for (var i = this.facilities.length - 1; i >= 0; i--) {
        if (this.selectedCities.length > 0 && !this.selectedCities.includes(this.facilities[i].city)) {
          continue;
        }

        if (this.selectedCounties.length > 0 && !this.selectedCounties.includes(this.facilities[i].county)) {
          continue;
        }

        if (this.selectedRegions.length > 0) {
          const region = this.regions.find(region => region.RowKey === this.facilities[i].county);
          if (!this.selectedRegions.includes(region.PartitionKey)) {
            continue;
          }
        }

        if (this.selectedCare.length > 0) {
          var push = false;
          for (var ii = this.selectedCare.length - 1; ii >= 0; ii--) {
            if (this.facilities[i][this.selectedCare[ii].service_code.toLowerCase()] === 1 ) {
              push = true;
            } else if (this.facilities[i].PartitionKey === this.selectedCare[ii].service_code) {
              push = true;
            } else if (this.facilities[i].PartitionKey === 'MH' && this.selectedCare[ii].service_code === 'SUMH') {
              push = true;
            } else {
              push = false;
            }
          }

          if (!push) {
            continue;
          }
        }

        this.filteredFacilities.push(this.facilities[i]);
      }

      this.renderFacilityMarkers();
    },
    renderFacilityMarkers() {
      this.$refs.map.mapObject.eachLayer((layer) => {
        if (layer.options.pane === 'markerPane') {
          layer.remove();
        }
      });
      if (this.filteredFacilities.length === 0) { return; }
      for (var i = this.filteredFacilities.length - 1; i >= 0; i--) {
        if (typeof this.filteredFacilities[i] === 'undefined') { return; }
        let marker = circleMarker([this.filteredFacilities[i].lat, this.filteredFacilities[i].lng], {
          pane: 'markerPane',
          radius: 7,
          fillColor: this.serviceColors[this.filteredFacilities[i].PartitionKey],
          color: this.serviceColors[this.filteredFacilities[i].PartitionKey],
          weight: 1,
          fillOpacity: 0.7,
          stroke: false,
          RowKey: this.filteredFacilities[i].RowKey
        })
        .addTo(this.$refs.map.mapObject)
        .on('click', this.circleClick);
      }

      this.updateBounds();
    },
    circleClick(marker) {
      const facility = this.filteredFacilities.find(facility => facility.RowKey === marker.target.options.RowKey);
      this.popupFacility = facility;

      setTimeout(() => {
        this.$refs.popupMarker.mapObject.openPopup();
      }, 10);
    },
    watchSelected() {
      this.showFacilitiesList = true;
      this.buildFilteredFacilities();
      this.stopLoading();
    },
    rebuildOptions() {
      this.buildCities();
      this.buildCounties();
      this.buildRegionOptions();
      this.buildCareOptions();
    },
    stopLoading() {
      this.$nextTick(function () {
        this.loading = false;
        this.building = {
          cities: false,
          counties: false,
          regions: false,
          care: false
        };
      });
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    boundsUpdated() {},
    updateBounds() {
      const bounds = latLngBounds(this.filteredFacilities.map(o => [ o.lat, o.lng ]));
      this.bounds = bounds;
    },
    buildCities() {
      if (this.building.cities) { return; }
      this.building.cities = true;
      this.cities = [];
      for (var i = this.filteredFacilities.length - 1; i >= 0; i--) {
        if (!this.cities.includes(this.filteredFacilities[i].city)) {
          this.cities.push(this.filteredFacilities[i].city);
        }
      }

      this.cities.sort();
      this.building.cities = false;
    },
    buildCounties() {
      if (this.building.counties) { return; }
      this.building.counties =  true;
      this.counties = [];
      for (var i = this.filteredFacilities.length - 1; i >= 0; i--) {
        if (!this.counties.includes(this.filteredFacilities[i].county)) {
          this.counties.push(this.filteredFacilities[i].county);
        }
      }

      this.counties.sort();
      this.building.counties = false;
    },
    buildRegionOptions() {
      if (this.building.regions) { return; }
      this.building.regions = true;
      this.regionOptions = [];
      for (var i = this.regions.length - 1; i >= 0; i--) {
        if (!this.regionOptions.includes(this.regions[i].PartitionKey) && this.counties.includes(this.regions[i].RowKey)) {
          this.regionOptions.push(this.regions[i].PartitionKey);
        }
      }

      this.regionOptions.sort();
      this.building.regions = false;
    },
    buildCareOptions() {
      if (this.building.care) { return; }
      this.building.care = true;
      this.careOptions = [];
      const serviceList = this.buildServiceListRaw();

      for (var i = this.services.length - 1; i >= 0; i--) {
        if (!this.careOptions.includes(this.services[i])
          && this.services[i].PartitionKey === 'TC'
          && serviceList.includes(this.services[i].service_code)
         ) {
          this.careOptions.push(this.services[i]);
        }
      }

      this.careOptions.sort((a, b) => (a.service_name > b.service_name) ? 1 : -1);
      this.building.care = false;
    },
    findService(sc) {
      const service = this.services.find(service => service.service_code === sc);
      if (service) {
        return service;
      } else {
        return false;
      }
    },
    findServiceName(sc) {
      const service = this.services.find(service => service.service_code === sc);
      if (service) {
        return service.service_name;
      } else {
        return false;
      }
    },
    resetFilters() {
      this.loading = true;
      this.zoom = 6;

      this.selectedCities = [];
      this.selectedCounties = [];
      this.selectedRegions = [];
      this.selectedCare = [];

      setTimeout(() => {
        this.center = [31.5, -100];
      }, 500);
    },
    buildServicesList(facility, cat) {
      var services = [];
      for (const [key, value] of Object.entries(facility)) {
        if (value == 1) {
          const service = this.findService(key.toUpperCase());

          if (service && service.PartitionKey === cat) {
            services.push(service.service_name);
          }
        }
      }

      return services.join(', ');
    },
    buildServiceListRaw(facilities) {
      var services = [];
      for (var i = this.filteredFacilities.length - 1; i >= 0; i--) {
        for (const [key, value] of Object.entries(this.filteredFacilities[i])) {
          if (value == 1) {
            services.push(key.toUpperCase());
          }
        }
      }

      return services;
    },
    scrollMeTo(refName) {
      var timeout = 100;
      if (!this.showFacilitiesList) {
        this.showFacilitiesList = true;
      } else {
        timeout = 0;
      }

      setTimeout(() => {
        var element = this.$refs[refName];
        element = element.length === 1 ?  element[0] : element
        var top = element.offsetTop;
        window.scrollTo(0, top);
      }, timeout);
    }
  }
};
